export const contactInfo = {
    'tel': '+1 234 1122 123',
    'email': 'lizbeltran@email.com',
    'dir': 'Av. Los Rosales 122 28021, Tampa',
    'site': 'www.misite.com'
}
export const socials = {
    'facebook': 'path/to/facebook',
    'twiter': 'path/to/twiter',
    'telegram': 'path/to/telegram'
}